import TwoColumnContent from '../../../components/TwoColumnContent/TwoColumnContent';
import LeftColumn from '../../../components/TwoColumnContent/LeftColumn/LeftColumn';
import TitleDescription from '../../../components/TitleDescription/TitleDescription';
import RightColumn from '../../../components/TwoColumnContent/RightColumn/RightColumn';
import styles from '../EditTeamMember.module.css';
import React from 'react';
import { useIntl } from 'react-intl';
import { useEditTeamMember } from '../EditTeamMemberContext';
import { AdminSelect } from '@project/components';
import { USER_TITLES as titleOptions } from '../../../constants';

export const EditTeamMemberCompanyTitle = () => {
  const intl = useIntl();
  const t = id => intl.formatMessage({ id });

  const { user, setUser } = useEditTeamMember();

  return (
    <TwoColumnContent bottomBorder={true}>
      <LeftColumn>
        <TitleDescription
          title={t('EditTeamMember.companyTitle.title')}
          description={t('EditTeamMember.companyTitle.details')}
        />
      </LeftColumn>
      <RightColumn>
        <AdminSelect
          id="companyTitle"
          propStyles={styles.adminSelect}
          label={t('EditTeamMember.companyTitle.label')}
          defaultValue=""
          placeholder={t('EditTeamMember.companyTitle.placeholder')}
          options={titleOptions}
          value={user.companyTitle}
          onChange={e => setUser({ ...user, companyTitle: e })}
          isLoading={false}
        />
      </RightColumn>
    </TwoColumnContent>
  );
};
